{
  "actionbar.actions": "Ações",
  "actionbar.actionsAvailable": "Ações disponíveis.",
  "actionbar.clearSelection": "Limpar seleção",
  "actionbar.selected": "{count, plural, =0 {Nenhum selecionado} one {# selecionado} other {# selecionados}}",
  "actionbar.selectedAll": "Todos selecionados",
  "actionbutton.pending": "pendente",
  "breadcrumbs.more": "Mais itens",
  "button.pending": "pendente",
  "calendar.invalidSelection": "{selectedCount, plural, one {Data} other {Datas}} selecionada(s) indisponível(is).",
  "combobox.loading": "Carregando...",
  "combobox.loadingMore": "Carregando mais...",
  "combobox.noResults": "Nenhum resultado",
  "contextualhelp.help": "Ajuda",
  "contextualhelp.info": "Informações",
  "datepicker.endTime": "Hora final",
  "datepicker.startTime": "Hora inicial",
  "datepicker.time": "Hora",
  "dialog.alert": "Alerta",
  "dialog.dismiss": "Descartar",
  "dropzone.replaceMessage": "Solte o arquivo para substituir",
  "inlinealert.informative": "Informações",
  "inlinealert.negative": "Erro",
  "inlinealert.notice": "Aviso",
  "inlinealert.positive": "Sucesso",
  "label.(optional)": "(opcional)",
  "label.(required)": "(obrigatório)",
  "listview.loading": "Carregando...",
  "listview.loadingMore": "Carregando mais...",
  "menu.loading": "Carregando...",
  "menu.loadingMore": "Carregando mais...",
  "menu.moreActions": "Mais ações",
  "menu.noResults": "Nenhum resultado",
  "menu.unavailable": "Indisponível. Expanda para ver os detalhes",
  "notificationbadge.indicatorOnly": "Nova atividade",
  "notificationbadge.plus": "{notifications}+",
  "picker.loading": "Carregando...",
  "picker.loadingMore": "Carregando mais...",
  "picker.placeholder": "Selecionar…",
  "picker.selectedCount": "{count, plural, =0 {Nenhum item selecionado} one {# item selecionado} other {# itens selecionados}}",
  "sidepanel.collapse": "Recolher o painel lateral",
  "sidepanel.expand": "Expandir o painel lateral",
  "slider.maximum": "Máximo",
  "slider.minimum": "Mínimo",
  "table.cancel": "Cancelar",
  "table.drag": "Arraste",
  "table.editCell": "Editar célula",
  "table.loading": "Carregando...",
  "table.loadingMore": "Carregando mais...",
  "table.resizeColumn": "Redimensionar coluna",
  "table.save": "Salvar",
  "table.sortAscending": "Ordenar por ordem crescente",
  "table.sortDescending": "Ordenar por ordem decrescente",
  "tag.actions": "Ações",
  "tag.hideButtonLabel": "Mostrar menos",
  "tag.noTags": "Nenhum",
  "tag.showAllButtonLabel": "Mostrar tudo ({tagCount, number})",
  "toast.clearAll": "Limpar tudo",
  "toast.collapse": "Recolher",
  "toast.showAll": "Mostrar tudo",
  "treeview.loadingMore": "Carregando mais..."
}
